// if pbjs already exists in global document scope, use it, if not, create the object
// global defination should happen BEFORE imports to avoid global undefined errors.
window.pbjs = (window.pbjs || {});
window.pbjs.cmd = window.pbjs.cmd || [];
window.pbjs.que = window.pbjs.que || [];

export function getGlobal() {
  return window.pbjs;
}



// WEBPACK FOOTER //
// ./src/prebidGlobal.js